<template>
    <div id="purchase-items-wrap">
        <input type="hidden" v-model="reseter.counter">
        <span v-if="items && !items[fcn]">Loading...</span>
        <span v-if="!items">Loading Items...</span>
        <table class="tdm_table" v-if="items && items[fcn]">
            <tbody class="tdm_content" v-for="(car,cn) in cars" :key="cn">
                <tr class="tdm_heading">
                    <th colspan="2">Car #{{ car.car_id_number }}</th>
                    <th class="tdm_qty">Qty</th>
                    <th>Item</th>
                    <th class="tdm_price">Unit Price</th>
                    <th class="tdm_price">Amount</th>
                </tr>
                <template v-for="(g_items,g) in items[cn]">
                    <tr class="tdm_heading_opt" :key="g"><th colspan="5"> {{ getGroup(g) }} <input type="checkbox" checked value="N" v-model="exludegroups[cn][g]" @change="exludeGrp(cn,g)" @blur="exludeGrp(cn,g)" v-if="!isVerified"></th></tr>
                    <tr class="tdm_detail" v-for="(item,i) in g_items" :key="i">
                        <td class="tdm_include" v-if="!isVerified">
                            <input type="checkbox" checked value="N" v-model="item.exclude" @change="excludeItem(cn,g,item.item_key,i)">
                        </td>
                        <td class="tdm_name" :colspan="isVerified ? 2 : 1"><span>{{ item.label }}</span><i style="display: inline;">:</i></td>
                        <td class="tdm_qty">
                            <template v-if="isVerified">
                                <span>{{ item.qty }}</span>
                            </template>
                            <template v-else-if="isReel(item.item)">
                                <input type="number" v-model="item.qty" class="itemqty js-itemqty required" min="1" max="9999" maxlength="4" 
                                    :disabled="item.exclude === false"
                                    @keyup="adjustRope(cn,g,i)"
                                    @blur="adjustRope(cn,g,i)"
                                >
                            </template>
                            <template v-else>
                                <input type="number" v-model="item.qty" class="itemqty js-itemqty required" min="1" max="9999" maxlength="4" 
                                    :disabled="item.exclude === false"
                                    :readonly="isRope(item)"
                                    @keyup="getUnitCost(cn)"
                                    @blur="getUnitCost(cn)"
                                >
                            </template>
                        </td>
                        <td class="tdm_item">
                            <template v-if="isVerified">
                                <span>
                                    {{ item.item }}
                                    <template v-if="isRope(item)">
                                        <span>&nbsp;({{ items[cn][g][nextKey(cn,g,i)].qty }} X {{ item.length }} ft Rope)</span>
                                    </template>
                                </span>
                            </template>
                            <template v-else>
                                <span :class="item.isactive===false?'i-inactive':''">
                                    {{ item.item }}
                                    <template v-if="isRope(item)">
                                        (<input type="number" v-model="items[cn][g][nextKey(cn,g,i)].qty" class="itemqty js-itemqty required itemlen" 
                                            min="1" max="9999" 
                                            maxlength="4"
                                            :disabled="isVerified"
                                            @keyup="adjustRope(cn,g,nextKey(cn,g,i))"
                                            @blur="adjustRope(cn,g,nextKey(cn,g,i))"
                                        > 
                                        X
                                        <input type="number" v-model="item.length" class="itemqty js-itemqty required itemlen" 
                                            min="1" max="9999" 
                                            maxlength="4"
                                            :disabled="isVerified"
                                            @blur="adjustReel(cn,g,i)"
                                        > 
                                        ft Rope)
                                    </template>
                                </span>
                            </template>
                        </td>
                        <td class="tdm_price">
                            <i>$</i>
                            <span v-if="item.exclude !== false">{{ sesCurr(item.unit_price) }}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td class="tdm_price">
                            <i>$</i>
                            <span v-if="item.exclude !== false">{{ sesCurr(item.unit_price * item.qty) }}</span>
                            <span v-else>0.00</span>
                        </td>
                    </tr>
                </template>
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4">
                        <span>Unit Cost</span><i>:</i>
                        <span class="float-right">× <span>{{ car.car_qty }}</span></span>
                    </td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(car.unit_cost) }}</span></td>
                </tr>
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4"><span>Subtotal</span><i>:</i></td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(car.subtotal) }}</span></td>
                </tr>
                <tr class="tdm_sep"><th colspan="5">&nbsp;</th></tr>
            </tbody>
            <tbody class="tdm_content" v-if="tariff_fee">
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4"><span>Tariff</span><i>:</i></td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(tariff_fee) }}</span></td>
                </tr>
            </tbody>
            <tbody class="tdm_content" v-else-if="freightsurcharge">
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4"><span>Freight Surcharge</span><i>:</i></td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(freightsurcharge) }}</span></td>
                </tr>
            </tbody>
            <tbody class="tdm_content" v-if="tax_fee">
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4"><span>{{ tax }}% Sales Tax</span><i>:</i></td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(tax_fee) }}</span></td>
                </tr>
            </tbody>
            <tbody class="tdm_content" v-if="dropshipfee">
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4"><span>Drop Ship Fee</span><i>:</i></td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(dropshipfee) }}</span></td>
                </tr>
            </tbody>
            <tbody class="tdm_content">
                <tr class="tdm_subhead">
                    <td class="tdm_include"></td>
                    <td class="tdm_name" colspan="4"><span>Project Grand Total</span><i>:</i></td>
                    <td class="tdm_price"><i>$</i> <span>{{ formatPrice(total) }}</span></td>
                </tr>
            </tbody>
        </table>

        <div style="padding: 10px 10px 0;" class="js-wrapinput mt-1">
            <label>
                <input type="checkbox" class="js-purchase-agree required" v-model="reviewed" @change="reviewStep" :disabled="!items[fcn]"> &nbsp;
                <span class="required-indicator"> *</span> I reviewed all the {{ isVerified ? 'verified' : '' }} Items listed above.
            </label>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            total: 0,
            fcn: 1,
            isVerified: false,
            reviewed: false,
            tax_fee: 0,
            tariff_fee: 0,
            drop_ship_fee: 0,
            freight_surcharge: 0,
            exludegroups: {},
            reseter: { counter : 1 },
            model: {},
            groups: {
                machine: 'Machine System',
                bedplate_system: 'Bedplate System',
                other_system: 'Other System',
                components: 'Components',
                custom: 'Custom System',
                hpu: 'Hydraulic System',
            }
        }
    },
    props: {
        done: String,
        tax: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Car"
        },
        tariff: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Car"
        },
        dropshipfee: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Car"
        },
        freightsurcharge: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Car"
        },
        cars: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Car"
        },
        project: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Project"
        },
        items: {
            type: [String, Object, Array, Boolean],
            default: false,
            description: "Items"
        },
        reels: {
            type: [String, Object, Array, Boolean],
            default: false,
            description: "Items"
        },
    },
    mounted() {
        let user = localStorage.getItem('user')
        if(!user) {
            this.shipping_types = [
                { id: 8, name: 'Customer Account' },
                { id: 9, name: 'Customer Pickup' }
            ]
            this.model.shipping_type = 'Customer Account'
        }
        if ( this.project.status ) this.isVerified = this.project.status == 'VERIFIED';

        this.$emit('mounted', this.model)
    },
    watch: {
        'items'() {
            console.log('mod diff',this.items);

            if ( this.items ) {
                for ( var cn in this.items ) {
                    for ( var g in this.items[cn] ) {
                        if ( !this.exludegroups[cn] ) this.exludegroups[cn] = {};
                        this.exludegroups[cn][g] = 'N';
                    }
                    this.fcn = cn;
                }
            }
        },
        'cars'() {
            for ( var cn in this.cars ) this.getUnitCost(cn);
        },
        project: {
            handler: function(data) {
                console.log('ver',data.status);
                this.isVerified = data.status == 'VERIFIED';
            }
        }
    },
    methods: {
        isRope(item) {
            let rope = item.item.substring(0, 3) === '80-';
            if ( rope && !item.length && item.detail ) {
                let desc = item.detail.split(' '),
                    len = (desc && desc[0] && desc[2]) ? desc[2] : 0;
                item.length = len;
            }
            return rope;
        },
        isReel(item) {
            return item.toLowerCase().includes(' reel');
        },
        prevKey(cn,g,i) {
            let keys = Object.keys(this.items[cn][g]);
            let nextIndex = keys.indexOf(i) - 1;
            return keys[nextIndex];
        },
        nextKey(cn,g,i) {
            let keys = Object.keys(this.items[cn][g]);
            let nextIndex = keys.indexOf(i) +1;
            return keys[nextIndex];
        },
        adjustRope(cn,g,i) {
            let pkey = this.prevKey(cn,g,i),
                item = this.items[cn][g][pkey],
                reel = this.items[cn][g][i].qty,
                len = item.length;
            item.qty = reel * len;
            item.reel = reel;
            this.getUnitCost(cn);
            return false;
        },
        checkReel(cn,g,i) {
            let pkey = this.prevKey(cn,g,i),
                item = this.items[cn][g][pkey],
                reel = this.items[cn][g][i].qty,
                len = item.length;
            item.qty = reel * len;
            item.reel = reel;
            this.getUnitCost(cn);
            return false;
        },
        adjustReel(cn,g,i) {
            let item = this.items[cn][g][i],
                nkey = this.nextKey(cn,g,i),
                reeli = this.items[cn][g][nkey].item,
                reel = this.items[cn][g][nkey].qty,
                len = item.length,
                rsize = this.cars[cn].rope_size,
                maxlen = this.reels[reeli][rsize].max_length;
            console.log(maxlen);
            if ( len > maxlen ) {
                var lastreel = false,
                    newreel = false;
                for(var r in this.reels) {
                    if ( this.reels[r][rsize].max_length >= len ) newreel = r;
                    else lastreel = r;
                }
                newreel = newreel ? newreel : lastreel;
                if ( reeli != newreel) {
                    alert('Max length exceeded, changing Reel to: '+newreel);
                    this.items[cn][g][nkey].item = newreel;
                    this.items[cn][g][nkey].fprice = this.reels[newreel][rsize].price;
                    this.items[cn][g][nkey].unit_price = this.reels[newreel][rsize].price;
                    this.items[cn][g][nkey].change = true;
                }
            } else {
                let enewreel = false;
                for(let r in this.reels) {
                    if (len <= this.reels[r][rsize].max_length) {
                        enewreel = r;
                        break;
                    }
                }
                if ( reeli != enewreel) {
                    alert('Minimum length matched, changing Reel to: '+enewreel);
                    this.items[cn][g][nkey].item = enewreel;
                    this.items[cn][g][nkey].fprice = this.reels[enewreel][rsize].price;
                    this.items[cn][g][nkey].unit_price = this.reels[enewreel][rsize].price;
                    this.items[cn][g][nkey].change = true;
                }
            }
            item.qty = reel * len;
            item.reel = reel;
            this.getUnitCost(cn);
            return false;
        },
        getGroup(gkey) {
            let g = this.groups[gkey];
            return g ? g : gkey.replace('_', '');
        },
        exludeGrp(cn,g) {
            var gs = this.items[cn][g];
            for( var i in gs ) {
                this.items[cn][g][i].exclude = this.exludegroups[cn][g];
            }
            this.subReset();
            this.getUnitCost(cn);
        },
        reviewStep() {
            this.$emit('done', { reviewed : this.reviewed });
        },
        formatPrice(value) {
            value = parseFloat(value);
            let val = (value/1).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        sesCurr(val) {
            return this.formatMoney(val, 2, '.', ',');
        },
        formatMoney(number, decPlaces, decSep, thouSep) {
            decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
            decSep = typeof decSep === "undefined" ? "." : decSep;
            thouSep = typeof thouSep === "undefined" ? "," : thouSep;
            var sign = number < 0 ? "-" : "";
            var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
            var j = (j = i.length) > 3 ? j % 3 : 0;

            return sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
        },
        excludeItem(cn,g,key,i) {
            if ( key == 'rope_reel' ) {
                this.items[cn][g].wire_rope.exclude = this.items[cn][g].rope_reel.exclude;
            } else if ( this.isRope(this.items[cn][g][i]) ) {
                let nxtk = this.nextKey(cn,g,i);
                this.items[cn][g][nxtk].exclude = this.items[cn][g][i].exclude;
            } else if ( this.isReel(this.items[cn][g][i].item) ) {
                let prvk = this.prevKey(cn,g,i);
                this.items[cn][g][prvk].exclude = this.items[cn][g][i].exclude;
            }
            if ( key == 'wire_rope' ) {
                this.items[cn][g].rope_reel.exclude = this.items[cn][g].wire_rope.exclude;
            }
            this.subReset();
            this.getUnitCost(cn);
        },
        getUnitCost(cn) {
            var unitCost = 0,
                g_items = this.items[cn];
            for( var g in g_items ) {
                for ( var i in g_items[g] ) {
                    var item = g_items[g][i];
                    if ( item.exclude !== false ) unitCost += parseFloat(item.qty) * parseFloat(item.unit_price);
                }
            }
            this.cars[cn].unit_cost = unitCost;
            this.getSubtotal(cn);
        },
        getSubtotal(cn) {
            const subtotal = this.cars[cn].unit_cost * parseInt(this.cars[cn].car_qty);
            this.cars[cn].subtotal = subtotal;
            this.getTotal();
        },
        subReset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        getTariff() {
            var tariff = 0;
            if ( this.items && parseFloat(this.tariff) > 0 ) {
                for ( var cn in this.items ) {
                    for ( var g in this.items[cn] ) {
                        for ( var ik in this.items[cn][g] ) {
                            tariff += (this.items[cn][g][ik].qty * this.items[cn][g][ik].unit_price) * (this.items[cn][g][ik].tariff / 100);
                        }
                    }
                }
            }
            this.tariff_fee = tariff;
        },
        getTotal() {
            this.getTariff();
            
            var dsfee = this.dropshipfee ? parseFloat(this.dropshipfee) : 0;
            var total = 0;

            total += this.tariff_fee ? parseFloat(this.tariff_fee) : 0;

            total += this.freightsurcharge ? parseFloat(this.freightsurcharge) : 0;
            for( var cn in this.cars ) {
                total += parseFloat(this.cars[cn].subtotal);
            }

            if ( this.tax ) {
                var tax = total * ( this.tax / 100 );
                this.tax_fee = tax;
                total += tax;
            }

            total += dsfee;

            this.total = total;

            this.subReset();

            this.$emit('data', { changes : this.getChanges() });
        },
        getChanges() {
            var dsf = this.dropshipfee ? parseFloat(this.dropshipfee) : 0,
                fsf = this.freightsurcharge ? parseFloat(this.freightsurcharge) : 0,
                tsf = this.tariff ? parseFloat(this.tariff) : 0,
                changes = {
                'exclude_keys' : '',
                'qty_changes' : '',
                'reel_changes' : '',
                'hastotal' : this.total > dsf + fsf + tsf ? 1 : 0
            };
            console.log('pi_changes',changes);
            console.log('pi_changes_tariff',this.tariff);
            console.log('pi_changes_ds',this.dropshipfee);
            console.log('pi_changes_fs',this.freightsurcharge);
            console.log('model',this.model);
            console.log('model',this.items);
            for( var cn in this.items ) {
                for( var g in this.items[cn] ) {
                    for ( var i in this.items[cn][g] ) {
                        var item = this.items[cn][g][i];
                        if ( item.exclude === false ) changes.exclude_keys += item.id+',';
                        if ( item.o_qty && item.qty != item.o_qty ) {
                            let reel = item.reel && item.length ? ':'+item.reel+'X'+item.length : '';
                            changes.qty_changes += item.id+':'+item.qty+reel+',';
                        }
                        if ( item.change ) {
                            changes.reel_changes += item.id+':'+item.item+',';
                        }
                    }
                }
            }
            return changes;
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('#shipping-wrap .hasError')).forEach(function(el) { 
                el.classList.remove('hasError');
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.input-wrap {
    padding: 2px 10px;
}
.i-inactive {
    color: red !important;
}
.plabel {
    padding-top: 7px;
}
.no-pr {
    padding-right: 2px;
}
.no-pl {
    padding-left: 0;
}
.tdm_heading_opt { 
    text-transform: capitalize;
    th {
        padding-top: 0.5em;
    }
}
.tdm_table .tdm_qty,
.tdm_table .tdm_include { text-align: center; }
.tdm_table td, .tdm_table th { 
    width: auto;
    border: 1px solid #e6e6e6;
}
.tdm_table input, .tdm_table select {
    border: 1px solid #ccc;
}
.tdm_table .tdm_include { width: 32px; }
.tdm_table .tdm_qty { width: 52px; }
.tdm_sep {
    th {
        height: 1em;
        border: 0;
    }
}

.itemlen {
    margin-left: 0px !important;
    margin-right: 0px !important;
}
@media (max-width: 768px) {
    .input-wrap {
        padding: 0;
    }
    .plabel {
        text-align: left !important;
    }
    .no-pr {
        padding-right: 15px;
    }
    .no-pl {
        padding-left: 15px;
    }
    .col-md-3, .col-md-6 {
        margin-bottom: 2px;
    }
}
</style>